import { pageContainerStyle } from '@commonStyle';
import { Platform, StyleSheet, useWindowDimensions } from 'react-native';

export default function useDroitsStyles(){
  const { width } = useWindowDimensions();
  const isTablet = width >= 768;
  const tabletScale = 1.5

  const styles = StyleSheet.create({
    container: {
      ...pageContainerStyle,
      backgroundColor: '#ffffff',
      paddingHorizontal: 16,
      paddingTop: 20,
    },
    scrollContainer: {
      maxHeight: '100%',
    },
    dataText: {
      color: 'black',
    },
    safeArea: {
      ...pageContainerStyle,
      flex: 1,
      backgroundColor: '#FFFFFF',
    },
    titre: {
      fontSize: 24,
      fontWeight: 'bold',
      color: '#00448F',
      textAlign: 'center',
      marginVertical: 15,
    },
    modernCard: {
      backgroundColor: 'white',
      padding: 20,
      margin: 12,
      borderRadius: 16,
      elevation: 4,
      shadowOpacity: 0.1,
      shadowRadius: 8,
      shadowOffset: { width: 0, height: 4 },
      borderWidth: 1,
      borderColor: '#e0e0e0',
      ...Platform.select({
        ios: {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.1,
          shadowRadius: 4,
        },
        web: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
      }),
    },
    cardHeader: {
      marginBottom: 16,
    },
    typeContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
    },
    typeTitle: {
      fontSize: 22,
      fontWeight: 'bold',
    },
    mainInfo: {
      alignItems: 'center',
      marginBottom: 20,
      paddingVertical: 16,
      backgroundColor: '#f8f9fa',
      borderRadius: 12,
    },
    primaryStat: {
      alignItems: 'center',
    },
    primaryLabel: {
      fontSize: 14 * (isTablet ? tabletScale : 1),
      color: '#666',
      marginBottom: 4,
    },
    primaryValue: {
      fontSize: 32 * (isTablet ? tabletScale : 1),
      fontWeight: 'bold',
    },
    quickStats: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      paddingVertical: 12,
      borderTopWidth: 1,
      borderTopColor: '#e9ecef',
    },
    statItem: {
      alignItems: 'center',
    },
    statLabel: {
      fontSize: 12 * (isTablet ? tabletScale : 1),
      color: '#666',
      marginBottom: 4,
    },
    statValue: {
      fontSize: 16 * (isTablet ? tabletScale : 1),
      fontWeight: '600',
      color: '#333',
    },
    nextYearInfo: {
      marginTop: 12,
      padding: 12,
      backgroundColor: '#e3f2fd',
      borderRadius: 8,
    },
    nextYearLabel: {
      fontSize: 13,
      color: '#1976d2',
      textAlign: 'center',
    },
    tapHint: {
      fontSize: 12 * (isTablet ? tabletScale : 1),
      color: '#999',
      textAlign: 'center',
      marginTop: 8,
      fontStyle: 'italic',
    },
  });

  return {styles};
}

